import { AppLogoSvg } from '@/React/Shared/Component/AppLogoSvg'

interface AppLogoProps {
    appName: string
}

export function AppLogo({ appName }: AppLogoProps) {
    return (
        <div className="flex items-center justify-start gap-2">
            <AppLogoSvg className="h-5 w-5" />
            <span className="text-lg font-semibold whitespace-nowrap">
                {appName}
            </span>
        </div>
    )
}
